import React, { Component} from 'react'
import ReactDOM from "react-dom";
import DashStore from './dashboard/Store/DashStore';
import GroupedBar from './charts/GroupedBar'

class ReservationChart extends Component {
    render() {
        DashStore.loadReservation(0);
        return <GroupedBar chartOpt={ DashStore.reservationChart } />
    }
}

const domContainer = document.getElementById('reservationChart')

if (domContainer) {
    const elem = React.createElement
    ReactDOM.render(elem(ReservationChart), domContainer)
}